
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import NevronClickConfirm from '@/components/NevronClickConfirm.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import hexColorCode from '@/helpers/hexColorCode';
import getInitials from '@/helpers/initials';
import PageHeader from '@/components/partials/page-header.vue';
import _ from 'lodash';
import CreateModule from './Create.vue';
import PerPageDropdown from '@/components/PerPageDropdown.vue';
import ListNevronHeader from '@/components/ListNevronComponents/ListNevronHeader.vue';
import EmptyNevronHeader from '@/components/ListNevronComponents/EmptyNevronHeader.vue';

@Component({
  components: {
    vPagination,
    ListNevronHeader,
    EmptyNevronHeader,
    Skeleton,
    NevronSearch,
    NevronSearchNoResults,
    NevronClickConfirm,
    PageHeader,
    CreateModule,
    PerPageDropdown,
  },
})

export default class ModulesList extends Vue {
  watchSkip = true;
  items = stores.modules;
  modules: object = [];
  response: any = null;
  perpage = 20;

  search: any = {
    query: '',
    current: '',
  };

  file: any = '';
  uploadResponse: any = '';
  exportData: any = '';

  message: any = {
    import: '',
    export: '',
    message: '',
  };

  searchItems = _.debounce(() => {
    this.fetchData(1, this.search.query, this.perpage);
  }, 400);

  /*
   * Watch for pagination
   */
  @Watch('response.currentPage')
  ChangePage() {
    if (this.watchSkip) {
      this.watchSkip = false;
    } else {
      this.search.query = this.search.current;
      this.fetchData(this.response.currentPage, this.search.current, this.perpage);
    }
  }

  perPageChange() {
    this.fetchData(1, this.search.query, this.perpage);
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    // // set search query from URL
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }
    // //
    // // // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    //
    // // load data
    this.fetchData(index, '', this.perpage);

    // console.log(this.modules);
  }

  refresh() {
    this.fetchData(1, '', this.perpage);
    this.message.result = '';
    this.message.message = '';
  }

  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(index: number | null, search: string | null, perpage: number | 10) {
    stores.modules.fetchData(index, search, perpage)
      .then((response: any) => {
        this.search.current = this.search.query;
        this.response = response;
        this.modules = this.response.data;
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  /*
   * Get initials from admin's name
   */
  getInitials(str: string) {
    return getInitials(str);
  }

  /*
   * Get hex color code from string
   */
  hexColorCode(str: string) {
    return hexColorCode(str);
  }
}
